import {
  Box,
  Button,
  Center,
  HStack,
  Image,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Footer from "../components/common/Footer";
import Header from "../components/common/Header";

import Loading from "../components/common/Loading";
import groupImage from "../img/african-american-technicians.svg";
import { IAllAnnouncement } from "../models/announcement.model";
import registrationService from "../services/registration.service";
import routes from "./routes";

const DashboardAnnouncement = () => {
  const [announcements, setAnnouncements] = useState<IAllAnnouncement[]>([]);
  const [reload, setReload] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const navigate = useNavigate();

  const reloadData = () => {
    setReload(!reload);
  };

  useEffect(() => {
    // const url = `?year=${selectedYear}&page=${paginationDataGrant.current_page}`;
    registrationService.getAnnouncements().then((res) => {
      setAnnouncements(res.Announcements);
      console.log(res.Announcements.data, "Obalola");
      setIsLoading(false);
      // setPaginationDataGrant(res.pagination);
    });
  }, [reload]);

  const viewAnnouncement = async (announcement_id: string) => {
    navigate(routes.ViewAnnouncementLink(announcement_id));
  };

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <Box>
          <Header />
          <Center
            bgColor="#3362AB"
            width="100%"
            textAlign="center"
            pt={["30px", "72px"]}
            height={["320px", "350px", "400px"]}
            position={"relative"}
          >
            <Text color="white" fontSize={["40px", "48px"]} fontWeight="800">
              Announcements <br />& General Notice
            </Text>
          </Center>
          <VStack
            spacing="3rem"
            width="100%"
            bg="#F9F9F9"
            justifyContent="center"
            alignContent="center"
            // height="80rem"
            paddingY="3.2rem"
          >
            {announcements?.map((each: IAllAnnouncement, index) => (
              <Box
                key={index}
                width="70%"
                bg="white"
                height="20rem"
                padding="2.2rem"
                margin="0 auto"
                paddingTop="3rem"
                paddingBottom="3rem"
                cursor="pointer"
                // onClick={() => navigate(routes.AnnouncementDetail)}
                onClick={() => viewAnnouncement(each.uuid)}
              >
                <HStack spacing="2rem">
                  <Image
                    src={each?.attachment ? each.attachment : groupImage}
                    alt={each?.attachment ? "Attachment" : "Group Image"}
                    width="300px"
                    height="200px"
                    borderRadius="8px"
                    objectFit="cover"
                  />
                  <Box>
                    <HStack justifyContent="space-between">
                      <HStack>
                        <Button colorScheme="red">PUBLISHED ON</Button>
                        <Text>
                          {new Date(each.created_at).toLocaleDateString(
                            "en-US",
                            {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                            }
                          )}
                        </Text>
                      </HStack>
                      {/* <HStack>
                    <DownloadIcon color="red" />
                    <Text fontWeight="500" fontSize="14px" color="red">
                      Download Document
                    </Text>
                  </HStack> */}
                    </HStack>
                    <Text fontSize="24px" fontWeight="700">
                      {each.title}
                    </Text>
                    <Text>
                      {each.description
                        ? each.description.substring(0, 200) + "..."
                        : "Description not available"}
                      <Text as="span" color="red">
                        read more
                      </Text>
                    </Text>
                  </Box>
                </HStack>
              </Box>
            ))}
            {/* <Box
          width="70%"
          bg="white"
          height="20rem"
          padding="2.2rem"
          margin="0 auto"
          paddingTop="3rem"
          paddingBottom="3rem"
        >
          <HStack spacing="2rem">
            <Image
              src={groupImage}
              alt=""
              width="300px"
              height="200px"
              borderRadius="8px"
            />
            <Box>
              <HStack justifyContent="space-between">
                <HStack>
                  <Button colorScheme="red">PUBLISHED ON</Button>
                  <Text>AUGUST 13, 2021 </Text>
                </HStack>
                <HStack>
                  <DownloadIcon color="red" />
                  <Text fontWeight="500" fontSize="14px" color="red">
                    Download Document
                  </Text>
                </HStack>
              </HStack>
              <Text fontSize="24px" fontWeight="700">
                Vital information to all admitted candidates for the ngsdp
                2019/2020 session
              </Text>
              <Text>
                All Candidates should please note the following and act
                appropriately Participants are to arrive their orientation
                programme venue as specified in their confirmed admission letter
                on Sunday, 2nd February, 2020 Verification of educational
                credentials and registration for the programme will hold..{" "}
                <Text as="span" color="red">
                  read more
                </Text>
              </Text>
            </Box>
          </HStack>
        </Box> */}
          </VStack>
          <Footer />
        </Box>
      )}
    </>
  );
};

export default DashboardAnnouncement;
